import {connect} from 'react-redux';
import SeatSpinner from './SeatSpinner.jsx';

import {selectFreeSeating, toggleShowFreeSeatingPopup} from '../../redux/seatingplanPageReducer';
import sponsorCodeService from "../../lib/sponsorCodes-service";

// Styles

// Helpers

function createRotateString(element) {
	return (
		`rotate(${element.angle} ` +
		`${element.x + (element.width / 2)} ` +
		`${element.y + (element.height / 2)})`
	);
}

function calculateTextFontSize(element) {
    /* The text is always wider than it's high, so we can scale the font size with a bigger factor when the element's
    width is also significantly bigger than its height. The factors are derived experimentally by observing the relation
    between the fontsize and the element's dimensions at various shapes and orientations. */
    if (element.width / element.height >= 2.5) {
        /* The height is used here for scaling, so that the text doesn't vertically overflow
         on very wide but shallow elements. */
        return element.height * 0.25;
    }
    return element.width * 0.095;
}

function determinePlural(number) {
	if (number === 1) {
		return '1 Platz';
	}
	return `${number} Plätze`;
}

function determineText(freeSeatingState, selectedAmount, amountFreeSeatingSponsorReservations) {
	if (selectedAmount > 0) {
		return `${determinePlural(selectedAmount)} ausgewählt`;
	}
	if (freeSeatingState) {
		return `${determinePlural(freeSeatingState.availableTickets - amountFreeSeatingSponsorReservations)} frei`;
	}
	return '';
}

// RenderFunction

function FreeSeatingArea(props) {
	const e = props.element;

	const text = determineText(props.freeSeatingState, props.selectedTktAmount, props.amountFreeSeatingSponsorReservations);

	const rotateString = createRotateString(e);
	const fontSize = calculateTextFontSize(e);
	const strokeWidth = props.selected ? 6 : 1;
	const ticketUnavailable = !props.freeSeatingState || props.freeSeatingState.availableTickets  - props.amountFreeSeatingSponsorReservations < 1 || !props.anyPlSelectable;
	const seatColor = (ticketUnavailable
		&& !props.selected) ? '#FFF' : props.color;
	const showCross = ticketUnavailable && !props.selected;
	const showText = !(props.seatInProcess === props.seatIdentifier) && !showCross && text;
	const hiddenByCategory = !props.categorySelected && !props.selected && !ticketUnavailable;
	const showSpinner = props.seatInProcess === props.seatIdentifier;

	const isClickable = !hiddenByCategory && !props.seatInProcess && props.anyPlSelectable;

	const clickHandler = isClickable && !showCross ? props.freeSeatingClicked : () => { };
	const selectedStrokeColor = '#575757';
	const unselectedStrokeColor = '#757575';

	const keyHandler = (event) => {
		if ((event.key === 'Enter') && isClickable && !showCross){
			return props.freeSeatingClicked()}
		return () => {
		}
	}

	return (
		<g onClick={clickHandler} transform={rotateString} onKeyDown={(event) => keyHandler(event)} className={isClickable ? 'clickable':'not-clickable'}
			tabIndex={isClickable ? 0 : -1} aria-label={'Freie Platzwahl: Block' + e.block + (props.cat? ',  Kategorie: ' + props.cat.categoryName : '')}>
			<rect // emulate stroke because of slow perfomance with rotation on mobile
				x={e.x}
				y={e.y}
				width={e.width}
				height={e.height}
				fill={props.selected ? selectedStrokeColor : unselectedStrokeColor}
			/>
			{props.selected &&
				<rect // emulate stroke because of slow perfomance with rotation on mobile
					x={e.x + (strokeWidth / 2)}
					y={e.y + (strokeWidth / 2)}
					width={e.width - strokeWidth}
					height={e.height - strokeWidth}
					fill="#FFF"
				/>
			}

			<rect
				x={e.x + strokeWidth}
				y={e.y + strokeWidth}
				width={e.width - (strokeWidth * 2)}
				height={e.height - (strokeWidth * 2)}
				fill={seatColor}
			/>

			{ showSpinner &&
				<SeatSpinner element={e} seatColor={seatColor} />
			}

            {showText &&
                /* weil Texte leider sehr stark auf die perfomance gehen
			    muss das vllt anders gemacht werden, falls wir ein PerformanceProblem haben*/
                <text
                    x={e.x + e.width / 2}
                    y={e.y + e.height / 2}
                    fontSize={fontSize}
                    fill="#000"
                    dominantBaseline="middle"
                    textAnchor="middle"
                >
                    {text}
                </text>
            }

			{showCross &&
				<g>
					<line
						x1={e.x + strokeWidth}
						y1={e.y + strokeWidth}
						x2={(e.x + e.width) - strokeWidth}
						y2={(e.y + e.height) - strokeWidth}
						stroke="#757575"
					/>
					<line
						x1={e.x + strokeWidth}
						y1={(e.y + e.height) - strokeWidth}
						x2={(e.x + e.width) - strokeWidth}
						y2={e.y + strokeWidth}
						stroke="#757575"
					/>
				</g>
			}

			{ hiddenByCategory &&
				<rect
					x={e.x}
					y={e.y}
					width={e.width}
					height={e.height}
					fill="#FFFFFF"
					fillOpacity="0.95"
				/>
			}
		</g>
	);
}

function getSeatIdentifier(element) {
	return `{B}${element.block || ''}` +
	`\u241F{R}${element.rowNumber || ''}` +
	`\u241F{S}${element.seatNumber || ''}`;
}

// ------------------------------
// Store Connection
// ------------------------------

const mapStateToProps = (state, props) => {
	const seatIdentifier = getSeatIdentifier(props.element);
	const freeSeatingState = state.seatState.freeSeatingInfoMap[seatIdentifier];

	//Sponsor-Codes
	const freeSeatingSponsorReservations = state.sponsorCodes.freeSeatReservations;
	const redeemedSponsorCodeUsages = Object.keys(state.sponsorCodes.codeUsagesPlUuidMap)
	const plsForRedeemedCodeUsages = Object.values(state.sponsorCodes.codeUsagesPlUuidMap)
	let amountFreeSeatingSponsorReservations = sponsorCodeService.getFreeSeatingAmountForSponsorReservations(freeSeatingSponsorReservations, seatIdentifier, redeemedSponsorCodeUsages)
	const isPlForRedeemedCodeAvailable = (pl) => {
		return plsForRedeemedCodeUsages.indexOf(pl.priceLevelUuid) !== -1
	}

	const event = state.event.elements[state.event.selected];
	let cat = null;
	let anyPlSelectable = false;
	let color = '#000000';
	let categorySelected = true;
	if (freeSeatingState) {
		cat = event.categories.find(cCat => cCat.categoryUUID === freeSeatingState.categoryUuid);
		anyPlSelectable = [cat.standardPriceLevel, ...cat.reducedPriceLevels]
			.some(pl => (!pl.accessCodeNeeded || state.accessCodes.plUuidCodeMap[pl.priceLevelUuid]) || (!pl.forSponsors || isPlForRedeemedCodeAvailable(pl)));
		color = cat.color;
		categorySelected = state.categoryFilter.showAll ||
			state.categoryFilter.selectedCategories.indexOf(freeSeatingState.categoryUuid) >= 0;
	}
	const seatInProcess = state.shoppingCart.seatInProcess;

	const shoppingCart = !state.shoppingCart.elements[state.merchant.merchantId] ? {} : state.shoppingCart.elements[state.merchant.merchantId];
	const selectedTktAmount = !shoppingCart.events ? 0 :
	shoppingCart.events.flatMap(scEvent => scEvent.displayTickets)
		.filter(displayTicket => (displayTicket.seatIdentifier === seatIdentifier
			&& displayTicket.categoryUuid === state.seatState.freeSeatingInfoMap[seatIdentifier].categoryUuid))
		.reduce((sum, displayTicket) => (sum + displayTicket.numberOfSeats), 0);

	const selected = state.selectedSeats.selectedFreeSeatings.indexOf(seatIdentifier) !== -1;

	return {
		seatIdentifier,
		freeSeatingState,
		amountFreeSeatingSponsorReservations,
		color,
		selected,
		categorySelected,
		cat,
		seatInProcess,
		selectedTktAmount,
		anyPlSelectable,
	};
};

const mapDispatchToProps = (dispatch, ownProps) => ({
	freeSeatingClicked: async () => {
		await dispatch(selectFreeSeating(getSeatIdentifier(ownProps.element)));
		dispatch(toggleShowFreeSeatingPopup());
	},
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(FreeSeatingArea);
